import { create } from 'zustand';
import { deleteNotificationforUser, getNotifications, markAllNotificationsAsRead, markNotificationAsRead } from '../api/NotificationRequest';
import { message } from 'antd';

const useStateStore = create((set) => ({
    notificationDetails: null,
    notificationCount: null,
    fetchLoading: false,
    markAsReadLoading: false,
    markAllAsReadLoading: false,
    deleteLoading: false,

    // Set authentication state
    fetchNotifications: async (page, limit, userId) => {
        set({ fetchLoading: true });
        try {

            const notifPage = page || 1
            const notifLimit = limit || 10
            const { data } = await getNotifications(notifPage, notifLimit)
            // console.log(data, 'data from state ');

            const count = data.notifications.filter(notification =>
                notification.reciversId.some(
                    receiver => receiver.reciverId === userId && !receiver.isRead
                )
            ).length

            set({
                notificationDetails: data.notifications,
                // notificationCount: count,
                notificationCount: data.unreadCount,
                fetchLoading: false
            })
        } catch (error) {
            console.log('fetchNotifications error', error);
            set({ fetchLoading: false });

        }
    },

    markAsReadNotifications: async (notificationId, userId) => {
        set({ markAsReadLoading: true });
        try {
            const { data } = await markNotificationAsRead(notificationId);
            // console.log(data, 'from state');


            // Update the local state with the marked notification
            if (data.success) {
                set((state) => ({
                    notificationDetails: state.notificationDetails.map(notification => {
                        // if (notification._id === notificationId) {
                        //     return {
                        //         ...notification,
                        //         reciversId: notification.reciversId.map(receiver =>
                        //             receiver.reciverId === userId
                        //                 ? { ...receiver, isRead: true, readAt: new Date() }
                        //                 : receiver
                        //         ),
                        //     };
                        // }
                        if (notification._id === notificationId) {
                            const updatedReciversId = notification.reciversId.map((receiver) =>
                                receiver.reciverId === userId ? { ...receiver, isRead: true, readAt: new Date() } : receiver
                            );
                            return { ...notification, reciversId: updatedReciversId };
                        }
                        // console.log(notification, 'loggggeddd');

                        return notification;
                    }),
                    notificationCount: state.notificationCount > 0 ? state.notificationCount - 1 : 0,
                    markAsReadLoading: false
                }));
                message.success("Marked Notification as Readed")
                
            }
        } catch (error) {
            console.error('Error marking notification as read:', error);
            set({ markAsReadLoading: false });
        }
    },

    markAllAsReadNotifications: async (userId) => {
        set({ markAllAsReadLoading: true });
        try {
            const { data } = await markAllNotificationsAsRead();

            // Update all notifications to mark as read in the local state
            if (data.success) {
                set((state) => ({
                    notificationDetails: state.notificationDetails.map(notification => ({
                        ...notification,
                        reciversId: notification.reciversId.map(receiver =>
                            receiver.reciverId === userId
                                ? { ...receiver, isRead: true, readAt: new Date() }
                                : receiver
                        ),
                    })),
                    notificationCount: 0,
                    markAllAsReadLoading: false
                }));

                message.success("Marked All Notification as Readed")
            }
        } catch (error) {
            console.error('Error marking all notifications as read:', error);
            set({ markAllAsReadLoading: false });
        }
    },

    deleteNotification: async (notificationId, userId) => {
        set({ deleteLoading: true });
        try {
            const { data } = await deleteNotificationforUser(notificationId); // Call the API to delete

            if (data.success) {
                // set((state) => ({
                //     notificationDetails: state.notificationDetails.filter(
                //         (notification) => notification._id !== notificationId
                //     ),
                //     notificationCount: state.notificationCount - 1,
                //     deleteLoading: false
                // }));

                set((state) => {
                    const notificationToDelete = state.notificationDetails.find(
                        (notification) => notification._id === notificationId
                    );

                    const isUnread = notificationToDelete?.reciversId.some(
                        (receiver) => receiver.reciverId === userId && !receiver.isRead
                    );

                    return {
                        notificationDetails: state.notificationDetails.filter(
                            (notification) => notification._id !== notificationId
                        ),
                        notificationCount: isUnread
                            ? state.notificationCount - 1
                            : state.notificationCount,
                            deleteLoading: false
                    };
                });

                message.success("Notification deleted")
            }
        } catch (error) {
            console.error("Failed to delete notification:", error);
            set({ deleteLoading: false });
        }
    },

    // Log out and clear user data
    logout: () => set({ isAuthenticated: false, user: null }),

    // Set card details
    setStateDetails: (details, count) => {
        try {
            set({
                notificationDetails: details,
                notificationCount: count
            })
        } catch (error) {
            set({
                notificationDetails: null,
                notificationCount: null
            })
        }
    },

    // Clear card details
    clearStateDta: () => {
        try {
            set({
                notificationDetails: null,
                notificationCount: null
            })
        } catch (error) {
            set({
                notificationDetails: null,
                notificationCount: null
            })
        }
    },

    // Set theme
    setTheme: (theme) => set({ theme }),
}));




// Hydrate the store with data from localStorage on creation
const storedState = JSON.parse(localStorage.getItem("globalState")) || {};
useStateStore.setState(storedState);

// Subscribe to state changes and persist the state to localStorage
useStateStore.subscribe((state) => {
    localStorage.setItem("globalState", JSON.stringify(state));
});

export default useStateStore;
